import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UpdatePublicSessionOrganizationSettingsGQL } from '../../../../../../../../photographer-panel/src/graphql';
import { BehaviorSubject } from 'rxjs';
import { firstValueFrom } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';
import { UploadContext } from 'Upload/upload/graphql';
import { UploadService } from 'ZalamoLibrary/src/lib/upload/upload.service';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { TabloProjectStateSyncService } from '@ui/tablo-generator/tablo-studio/tablo-project-state-sync.service';
import { isUnsupportedJpegColorSpaceError } from 'ZalamoLibrary/src/lib/core/image/image-metadata.service';

@Component({
  selector: 'lib-tablo-fix-school-logo',
  templateUrl: './tablo-fix-school-logo.component.html',
  styleUrls: ['./tablo-fix-school-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabloFixSchoolLogoComponent implements OnInit {
  @Input() publicSessionOrganizationId!: string;
  progress$ = new BehaviorSubject(0);
  context = UploadContext.PublicSessionOrganizationLogo;

  constructor(
    private updatePublicSessionOrganizationSettingsGQL: UpdatePublicSessionOrganizationSettingsGQL,
    private uploadService: UploadService,
    private organizationService: OrganizationService,
    private tabloProjectStateSyncService: TabloProjectStateSyncService,
  ) {}

  ngOnInit(): void {}

  async filePicked($event: Event) {
    const input = $event.target as HTMLInputElement;
    const files = input.files;
    if (!files?.length) {
      return;
    }

    this.progress$.next(1);

    try {
      const logo = await firstValueFrom(
        this.uploadService.uploadSingleFile(
          files[0],
          this.context,
          await firstValueFrom(
            this.organizationService.getCurrentOrganization(),
          ),
        ),
      );
      this.progress$.next(100);
      this.tabloProjectStateSyncService.updateSchoolLogo(logo);
      await firstValueFrom(
        this.updatePublicSessionOrganizationSettingsGQL.mutate({
          variables: {
            publicSessionOrganizationId: this.publicSessionOrganizationId,
            settings: {
              logo,
            },
          },
        }),
      );
    } catch (error) {
      this.progress$.next(0);
      if (!isUnsupportedJpegColorSpaceError(error)) {
        console.error(error);
      }
    } finally {
      input.value = '';
    }
  }
}
